import { render, staticRenderFns } from "./TituloDePagina.vue?vue&type=template&id=2b4eab92&scoped=true&"
import script from "./TituloDePagina.vue?vue&type=script&lang=js&"
export * from "./TituloDePagina.vue?vue&type=script&lang=js&"
import style0 from "./TituloDePagina.vue?vue&type=style&index=0&id=2b4eab92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4eab92",
  null
  
)

export default component.exports